const DropdownIcon = () => {
  return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3635 5.29246C14.1759 5.10499 13.9216 4.99968 13.6565 4.99968C13.3913 4.99968 13.137 5.10499 12.9495 5.29246L7.99946 10.2425L3.04946 5.29246C2.86086 5.11031 2.60826 5.00951 2.34606 5.01179C2.08387 5.01407 1.83305 5.11924 1.64764 5.30465C1.46224 5.49005 1.35707 5.74087 1.35479 6.00306C1.35251 6.26526 1.45331 6.51786 1.63546 6.70646L7.29246 12.3635C7.47999 12.5509 7.7343 12.6562 7.99946 12.6562C8.26463 12.6562 8.51894 12.5509 8.70646 12.3635L14.3635 6.70646C14.5509 6.51894 14.6562 6.26463 14.6562 5.99946C14.6562 5.7343 14.5509 5.47999 14.3635 5.29246Z"
          fill="#183883"
        />
      </svg>
  );
};
export default DropdownIcon;
